export default __webpack_public_path__ + "images/referenzen/werbespot/barclays_tvc.mp4";